/**
 * FCT Account API
 * FCT Account API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: areche@ilernaonline.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */


import ApiClient from "../ApiClient";
import DefaultApiResponse from '../model/DefaultApiResponse';
import DownloadResponse from '../model/DownloadResponse';
import FileRemovedResponse from '../model/FileRemovedResponse';
import ProtoDocumentResponse from '../model/ProtoDocumentResponse';
import UploadResponse from '../model/UploadResponse';

/**
* PrecontractDocuments service.
* @module api/PrecontractDocumentsApi
* @version 1.0.0
*/
export default class PrecontractDocumentsApi {

    /**
    * Constructs a new PrecontractDocumentsApi. 
    * @alias module:api/PrecontractDocumentsApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instance} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }



    /**
     * Elimina un documento
     * Elimina un documento previamente subido
     * @param {Number} precontractId ID del precontrato
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/FileRemovedResponse} and HTTP response
     */
    apiV1MyaccountProtoDocumentDeletePrecontractIdDeleteWithHttpInfo(precontractId) {
      let postBody = null;
      // verify the required parameter 'precontractId' is set
      if (precontractId === undefined || precontractId === null) {
        throw new Error("Missing the required parameter 'precontractId' when calling apiV1MyaccountProtoDocumentDeletePrecontractIdDelete");
      }

      let pathParams = {
        'precontract_id': precontractId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = FileRemovedResponse;
      return this.apiClient.callApi(
        '/api/v1/myaccount/proto_document_delete/{precontract_id}', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null
      );
    }

    /**
     * Elimina un documento
     * Elimina un documento previamente subido
     * @param {Number} precontractId ID del precontrato
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/FileRemovedResponse}
     */
    apiV1MyaccountProtoDocumentDeletePrecontractIdDelete(precontractId) {
      return this.apiV1MyaccountProtoDocumentDeletePrecontractIdDeleteWithHttpInfo(precontractId)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * Descargar documento
     * Descarga un documento almacenado según su ID.
     * @param {Number} precontractId ID del precontrato
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/DownloadResponse} and HTTP response
     */
    apiV1MyaccountProtoDocumentPrecontractIdGetWithHttpInfo(precontractId) {
      let postBody = null;
      // verify the required parameter 'precontractId' is set
      if (precontractId === undefined || precontractId === null) {
        throw new Error("Missing the required parameter 'precontractId' when calling apiV1MyaccountProtoDocumentPrecontractIdGet");
      }

      let pathParams = {
        'precontract_id': precontractId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/octet-stream'];
      let returnType = DownloadResponse;
      return this.apiClient.callApi(
        '/api/v1/myaccount/proto_document/{precontract_id}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null
      );
    }

    /**
     * Descargar documento
     * Descarga un documento almacenado según su ID.
     * @param {Number} precontractId ID del precontrato
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/DownloadResponse}
     */
    apiV1MyaccountProtoDocumentPrecontractIdGet(precontractId) {
      return this.apiV1MyaccountProtoDocumentPrecontractIdGetWithHttpInfo(precontractId)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * Subir documento del precontracto
     * Sube un documento relacionado con un precontrato específico.
     * @param {Number} precontractId ID del precontrato
     * @param {Object} opts Optional parameters
     * @param {File} opts.file 
     * @param {String} opts.fileName 
     * @param {module:model/String} opts.documentType 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/UploadResponse} and HTTP response
     */
    apiV1MyaccountProtoDocumentPrecontractIdPostWithHttpInfo(precontractId, opts) {
      opts = opts || {};
      let postBody = null;
      // verify the required parameter 'precontractId' is set
      if (precontractId === undefined || precontractId === null) {
        throw new Error("Missing the required parameter 'precontractId' when calling apiV1MyaccountProtoDocumentPrecontractIdPost");
      }

      let pathParams = {
        'precontract_id': precontractId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
        'file': opts['file'],
        'file_name': opts['fileName'],
        'document_type': opts['documentType']
      };

      let authNames = [];
      let contentTypes = ['multipart/form-data'];
      let accepts = ['application/json'];
      let returnType = UploadResponse;
      return this.apiClient.callApi(
        '/api/v1/myaccount/proto_document/{precontract_id}', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null
      );
    }

    /**
     * Subir documento del precontracto
     * Sube un documento relacionado con un precontrato específico.
     * @param {Number} precontractId ID del precontrato
     * @param {Object} opts Optional parameters
     * @param {File} opts.file 
     * @param {String} opts.fileName 
     * @param {module:model/String} opts.documentType 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/UploadResponse}
     */
    apiV1MyaccountProtoDocumentPrecontractIdPost(precontractId, opts) {
      return this.apiV1MyaccountProtoDocumentPrecontractIdPostWithHttpInfo(precontractId, opts)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * Obtener documentos del precontrato
     * Obtiene la información y estado de los documentos relacionados con un precontrato específico.
     * @param {Number} precontractId ID del precontrato
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/ProtoDocumentResponse} and HTTP response
     */
    apiV1MyaccountProtoDocumentsPrecontractIdGetWithHttpInfo(precontractId) {
      let postBody = null;
      // verify the required parameter 'precontractId' is set
      if (precontractId === undefined || precontractId === null) {
        throw new Error("Missing the required parameter 'precontractId' when calling apiV1MyaccountProtoDocumentsPrecontractIdGet");
      }

      let pathParams = {
        'precontract_id': precontractId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = ProtoDocumentResponse;
      return this.apiClient.callApi(
        '/api/v1/myaccount/proto_documents/{precontract_id}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null
      );
    }

    /**
     * Obtener documentos del precontrato
     * Obtiene la información y estado de los documentos relacionados con un precontrato específico.
     * @param {Number} precontractId ID del precontrato
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/ProtoDocumentResponse}
     */
    apiV1MyaccountProtoDocumentsPrecontractIdGet(precontractId) {
      return this.apiV1MyaccountProtoDocumentsPrecontractIdGetWithHttpInfo(precontractId)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * Actualizar documentos del precontrato y marcar como validando
     * Actualiza los documentos relacionados con un precontracto específico.
     * @param {Number} precontractId ID del precontrato
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/DefaultApiResponse} and HTTP response
     */
    apiV1MyaccountProtoDocumentsPrecontractIdPutWithHttpInfo(precontractId) {
      let postBody = null;
      // verify the required parameter 'precontractId' is set
      if (precontractId === undefined || precontractId === null) {
        throw new Error("Missing the required parameter 'precontractId' when calling apiV1MyaccountProtoDocumentsPrecontractIdPut");
      }

      let pathParams = {
        'precontract_id': precontractId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = DefaultApiResponse;
      return this.apiClient.callApi(
        '/api/v1/myaccount/proto_documents/{precontract_id}', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null
      );
    }

    /**
     * Actualizar documentos del precontrato y marcar como validando
     * Actualiza los documentos relacionados con un precontracto específico.
     * @param {Number} precontractId ID del precontrato
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/DefaultApiResponse}
     */
    apiV1MyaccountProtoDocumentsPrecontractIdPut(precontractId) {
      return this.apiV1MyaccountProtoDocumentsPrecontractIdPutWithHttpInfo(precontractId)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


}
